import { computed, inject, Injectable } from '@angular/core';

import { IntelligenceSettingsDataService } from './intelligence-settings-data.service';

@Injectable({ providedIn: 'root' })
export class TellentAgentEnablementService {
  private readonly intelligenceSettings = inject(IntelligenceSettingsDataService);

  public readonly settingsEnabled = computed(() => {
    const settings = this.intelligenceSettings.settings();
    const hrAssistant = settings?.find(setting => setting.feature === 'hr_assistant');
    return this.intelligenceSettings.masterEnabled() && (hrAssistant?.enabled ?? false);
  });

  public ensureLoaded(): void {
    this.intelligenceSettings.fetchIfNotLoaded();
  }

  public reload(): void {
    this.intelligenceSettings.load();
  }
}
